import { render, staticRenderFns } from "./trackingdetails.vue?vue&type=template&id=087abf0d&scoped=true"
import script from "./trackingdetails.vue?vue&type=script&lang=js"
export * from "./trackingdetails.vue?vue&type=script&lang=js"
import style0 from "./trackingdetails.vue?vue&type=style&index=0&id=087abf0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087abf0d",
  null
  
)

export default component.exports